module.exports = __webpack_public_path__ + "img/01.6ee44932.webp";